import * as actionTypes from "../actionTypes/actionTypes";
import { getLoggedUserIdService, getLoggedUserRoleService } from "../services/AppService";

const getLoggedUserRoleAction = (payload) => {
    return async(dispatch) =>{
        dispatch({
            type:actionTypes.FETCH_USER_ROLE_START
        })
        await getLoggedUserRoleService(payload)
        .then((response) =>{
            const data = response.data;
            localStorage.setItem("loggedinUserRole",data.securityLevel);
            dispatch({
                type:actionTypes.FETCH_USER_ROLE_SUCCESS,
                payload:data
            })
        })
        .catch((error) =>{
            dispatch({
                type:actionTypes.FETCH_USER_ROLE_FAILURE,
                payload:error
            })
        })
    }
}

const getLoggedUserIdAction = (payload) => {
    return async(dispatch) => {
        dispatch({
            type:actionTypes.FETCH_USER_ID_START
        })
        await getLoggedUserIdService(payload)
        .then((response) => {
            const data = response.data;
            dispatch({
                type:actionTypes.FETCH_USER_ID_SUCCESS,
                payload:data
            })
        })
        .catch((error) =>{
            dispatch({
                type:actionTypes.FETCH_USER_ID_FAILURE,
                payload:error
            })
        })
    }
}

export {getLoggedUserRoleAction,getLoggedUserIdAction}
